import axios from 'axios';

const crisp = () => (window as any).$crisp;

/** Identifica o usuário e a loja no chat do Crisp (e de novo a cada sessão nova do chat). */
export function identifyCrispUser(user: { sub?: string; email?: string } | undefined, customer: string) {
  if (!user || !customer) return;
  axios.get(`/user/crisp-id`).then((response) => {
    if (!response) {
      console.error('Failed to fetch Crisp ID');
      return;
    }
    (window as any).CRISP_TOKEN_ID = user.sub;
    crisp()?.push(['set', 'user:email', [user.email, response.data]]);
    crisp()?.push(['set', 'session:data', [[['customer', customer]]]]);
    crisp()?.push(['set', 'user:company', [customer]]);
    crisp()?.push([
      'on',
      'session:loaded',
      function () {
        // Reenvia o email quando uma nova sessão é criada
        crisp()?.push(['set', 'user:email', [user.email, response.data]]);
      },
    ]);
  });
}

export function openCrispChat() {
  crisp()?.push(['do', 'chat:open']);
}
